import React from 'react';
import './style.css';

// Skeleton para os boxes do menu
export const BoxSkeleton = () => (
  <div className="col-md-3 d-flex align-items-stretch mb-5" style={{ maxWidth: 300 }}>
    <div className="skeleton-box">
      <div className="skeleton-icon"></div>
      <div className="skeleton-title"></div>
      <div className="skeleton-description"></div>
      <div className="skeleton-description short"></div>
    </div>
  </div>
);

// Skeleton para cards de aniversário
export const BirthdaySkeleton = () => (
  <div className="birthday-skeleton-card rounded mb-3">
    <div className="skeleton-name"></div>
    <div className="skeleton-date"></div>
  </div>
);

// Skeleton para o título de boas-vindas
export const WelcomeSkeleton = () => (
  <div className="row justify-content-center mt-5">
    <div className="skeleton-welcome"></div>
  </div>
);

// Skeleton para o título de aniversários
export const BirthdayTitleSkeleton = () => (
  <div className="skeleton-birthday-title mb-3"></div>
);

// Skeleton para tabela de membros
export const TableSkeleton = ({ rows = 10, columns = 7 }) => (
  <div className="table-skeleton-container">
    {/* Header da tabela */}
    <div className="table-skeleton-header">
      {Array(columns).fill(0).map((_, index) => (
        <div key={index} className="skeleton-table-header-cell"></div>
      ))}
    </div>
    
    {/* Linhas da tabela */}
    {Array(rows).fill(0).map((_, rowIndex) => (
      <div key={rowIndex} className="skeleton-table-row">
        {Array(columns).fill(0).map((_, colIndex) => (
          <div key={colIndex} className="skeleton-table-cell"></div>
        ))}
      </div>
    ))}
    
    {/* Paginação skeleton */}
    <div className="skeleton-pagination">
      <div className="skeleton-pagination-text"></div>
      <div className="skeleton-pagination-controls">
        <div className="skeleton-pagination-select"></div>
        <div className="skeleton-pagination-buttons"></div>
      </div>
    </div>
  </div>
);

// Skeleton para campo de busca
export const SearchSkeleton = () => (
  <div className="mb-3">
    <div className="skeleton-search-input">
      <div className="skeleton-search-placeholder"></div>
    </div>
  </div>
);

// Skeleton para formulário de edição
export const FormSkeleton = () => (
  <div className="form-skeleton-container">
    <div className="skeleton-form-title"></div>
    <div className="skeleton-form-subtitle"></div>
    <div className="skeleton-form-line"></div>
    
    <div className="skeleton-form-fields">
      {Array(12).fill(0).map((_, index) => (
        <div key={index} className="skeleton-form-field">
          <div className="skeleton-form-label"></div>
          <div className="skeleton-form-input"></div>
        </div>
      ))}
      
      <div className="skeleton-form-button"></div>
    </div>
  </div>
);

// Skeleton para gráficos
export const ChartSkeleton = () => (
  <div className="chart-skeleton-container">
    <div className="skeleton-chart-box">
      <div className="skeleton-chart-title"></div>
      <div className="skeleton-chart-content"></div>
    </div>
  </div>
);

// Skeleton para gráfico de progresso/meta
export const ProgressChartSkeleton = () => (
  <div className="progress-chart-skeleton-container">
    <div className="skeleton-progress-title"></div>
    <div className="skeleton-progress-bar"></div>
    <div className="skeleton-progress-text"></div>
  </div>
);

// Skeleton para gráfico alto (status time)
export const TallChartSkeleton = () => (
  <div className="tall-chart-skeleton-container">
    <div className="skeleton-chart-box tall">
      <div className="skeleton-chart-title"></div>
      <div className="skeleton-chart-content tall"></div>
    </div>
  </div>
);
